import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex gap-x-4 items-center sm:col-span-2" }
const _hoisted_2 = { class: "flex h-6 items-center" }
const _hoisted_3 = ["href"]

import type { PrivacyPolicyProps } from "./PrivacyPolicyProps";
import Switch from "@/views/blocks/shared/section/forms/switch/Switch.vue";
import { handleHashNavigation } from "@/shared/utils/router/hashNavigation";

export default /*@__PURE__*/_defineComponent({
  __name: 'PrivacyPolicy',
  props: {
    text: {},
    linkText: {},
    href: {},
    validationMessage: {},
    agreed: { type: Boolean },
    accentColor: {}
  },
  emits: ["update:agreed"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "9349c694": (_ctx.accentColor)
}))



const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Switch, {
        "model-value": _ctx.agreed,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('update:agreed', $event))),
        "accent-color": _ctx.accentColor
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.text), 1)
        ]),
        _: 1
      }, 8, ["model-value", "accent-color"])
    ]),
    _createElementVNode("label", {
      class: "text-sm/6 text-gray-600 cursor-pointer",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('update:agreed', !_ctx.agreed)))
    }, [
      _createTextVNode(_toDisplayString(_ctx.text) + " " + _toDisplayString(" ") + " ", 1),
      _createElementVNode("a", {
        href: _ctx.href,
        class: "link-item text-sm/6",
        style: _normalizeStyle({ color: _ctx.accentColor }),
        onClick: [
          _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
          _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(handleHashNavigation) && _unref(handleHashNavigation)(...args)))
        ],
        target: "_blank",
        rel: "noopener noreferrer"
      }, _toDisplayString(_ctx.linkText), 13, _hoisted_3)
    ])
  ]))
}
}

})